export default "/_next/static/chunks/fonts/IBM Plex Sans Regular-259154b3efafb53b8f4523f60ae26e81.ttf";